import { render, staticRenderFns } from "./course-area-inspection.vue?vue&type=template&id=25bab3bd&scoped=true&"
import script from "./course-area-inspection.vue?vue&type=script&lang=js&"
export * from "./course-area-inspection.vue?vue&type=script&lang=js&"
import style0 from "./course-area-inspection.vue?vue&type=style&index=0&id=25bab3bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bab3bd",
  null
  
)

export default component.exports